"use strict";

var _slicedToArray = require("/root/website/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterProvider = exports.FooterContext = exports.useFooter = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.node,
  currentDevice: (0, _propTypes.oneOf)(['mobile', 'desktop'])
} : {};
var FooterContext = /*#__PURE__*/(0, _react.createContext)(null);
exports.FooterContext = FooterContext;

var useFooter = function useFooter() {
  return (0, _react.useContext)(FooterContext);
};

exports.useFooter = useFooter;

var FooterProvider = function FooterProvider(_ref) {
  var children = _ref.children,
      currentDevice = _ref.currentDevice;

  var _ref2 = (0, _react.useState)(currentDevice),
      _ref3 = _slicedToArray(_ref2, 2),
      device = _ref3[0],
      setDevice = _ref3[1];

  var handleResize = (0, _react.useCallback)(function () {
    setDevice(window.innerWidth < 1024 ? 'mobile' : 'desktop');
  }, [setDevice]);
  (0, _react.useEffect)(function () {
    if (currentDevice) return null;
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [device, handleResize, currentDevice]);
  return (0, _core.jsx)(FooterContext.Provider, {
    value: {
      device: device
    }
  }, children);
};

exports.FooterProvider = FooterProvider;
process.env.NODE_ENV !== "production" ? FooterProvider.propTypes = propTypes : void 0;
FooterProvider.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FooterProvider",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "currentDevice": {
      "type": {
        "name": "enum",
        "value": [{
          "value": "'mobile'",
          "computed": false
        }, {
          "value": "'desktop'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    }
  }
};